import { Observable, of, ReplaySubject } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../../store/app.service';
import { TasksService } from '../../tasks/tasks.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ILead } from '../../../core/models/lead.models';
import { ITask } from '../../../core/models/tasks.models';
import { ITag } from '../../../core/models/tags.models';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CampaignsApiService } from '../campaigns.apiservice';
import { TasksApiService } from '../../tasks/tasks.apiservice';
import { TagsApiService } from '../../../pages/tags/tags.apiservice';
import { LeadsApiService } from '../../leads/leads.apiservice';
import { IPermission } from '../../../core/models/auth.models';
import { getRolesForPage } from '../../../core/helpers/utility';
import { ICampaign } from '../../../core/models/campaigns.model';
import { OrdersApiService } from '../../orders/orders.apiservice';
import { ICampaignCheck } from '../../../core/models/campaigns.model';
import { DataFeedService } from '../../../shared/api/datafeed.service';
import { UtilityService } from '../../../core/helpers/utility.service';
import { IReportingPeriod } from '../../../core/models/reporting.models';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SubscriptionApiService } from '../../subscriptions/subscription.apiservice';
import { CAMPAIGN_STAGES, NOTES_TYPE, PAGE_NAMES, ROLES, ROLES_TYPE } from '../../../core/helpers/constants';
import { IColumn, LoadDataFromServer } from '../../../shared/components/datatable/datatable.model';
import { AddCampaignCheckModal } from '../../../shared/modals/add-campaign-check/add-campaigncheck.component';
import { LandingPageRequestComponent } from '../../forms/landing-page-request/landing-page-request.component';
import { TechRequestComponent } from '../../forms/tech-request/tech-request.component';
import { CreateTaskExternalModal } from '../../forms/create-task-external/create-task-external.component';
import { CampaignAnalysisModalComponent } from '../../../shared/modals/campaign-analysis/campaign-analysis-modal.component';
import { StrategyReviewFormComponent } from '../../forms/strategy-review-form/strategy-review-form.component';
import { CreativeRequestComponent } from '../../forms/creative-request/creative-request.component';
import { SendEmailModal } from '../../../shared/modals/send-email/send-email.component';
import { InstanceService } from '../../../core/instance/instance.service';
import { CampaignsService } from '../campaigns.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.scss']
})

export class CampaignDetailsComponent implements OnInit, OnDestroy {
  private tabOrder: Array<{ id: number; name: string; visible: boolean }> = [];

  orderColumns = [
    { title: 'ID', field: 'numericId', sortable: true, searchable: true, translate: true },
    { title: 'FROM', field: 'startDate', sortable: true, searchable: true, translate: true },
    { title: 'TO', field: 'endDate', sortable: true, searchable: true, translate: true },
    { title: 'AMOUNT', field: 'amount', sortable: true, searchable: true, translate: true, pipe: 'Currency', pipeArgs: ['USD', 'symbol', '1.0-2'] },
    { title: 'STATUS', field: 'status', sortable: true, searchable: true, translate: true, type: 'html' },
    { title: 'SUBSCRIPTION_ID', field: 'subscriptionNumericId', sortable: true, searchable: true, translate: true, anchorLink: true, anchorType: 'subscription', anchorParamsField: 'subscriptionId' },
    { title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true, translate: true, pipe: 'cleanupCampaign' },
    { title: 'GENERATED_ON', field: 'generatedOn', sortable: true, searchable: true, translate: true, pipe: 'P_AppDateFormat', pipeArgs: ['YYYY-MM-DD HH:mm'] },
  ]

  leadsColumns: Array<any> = [];

  active: number = 0;
  dataTotalCount: number = 0;
  leadsTotalCount: number = 0;

  ordersData: Array<any> = [];
  mostRecentOrder: any = {};

  isTiered: boolean = false;
  tierName: string = '';
  clientTags: Array<ITag> = [];
  campaignTags: Array<ITag> = [];

  get tierBannerClass(): string {
    const name = (this.tierName ?? '').toLowerCase();
    if (name.includes('basic')) return 'tier-banner--basic';
    if (name.includes('premium')) return 'tier-banner--premium';
    if (name.includes('standard')) return 'tier-banner--standard';
    return 'tier-banner--standard';
  }

  userId: string = '';

  savedSearchId!: string;
  
  doWhat: IPermission = {} as IPermission;
  leadsPermissions: IPermission = {} as IPermission;
  ordersPermissions: IPermission = {} as IPermission;
  campaignData: ICampaign = {} as ICampaign;

  isAdmin: boolean = false;
  isExternal: boolean = false;
  isClientOwner: boolean = false;
  isEmployee: boolean = false;
  showTasks: boolean = true;
  isLoaded: boolean = false;
  showOnlyMyTasks: boolean = true;
  showCompletedTasks: boolean = false;

  private loadEvent!: LoadDataFromServer;
  
  
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public CAMPAIGN_STAGES = CAMPAIGN_STAGES;
  public ROLES = ROLES;
  public ROLES_TYPE = ROLES_TYPE;

  columnsTasks: Array<IColumn> =  new Array<IColumn>();
  completedTasksColumns: Array<IColumn> = new Array<IColumn>();
  subscriptions: Array<any> = new Array<any>();
  tasksData: Array<ITask> = new Array<ITask>();
  permTasksData: Array<ITask> = new Array<ITask>();
  completedTasksData: Array<ITask> = new Array<ITask>();
  leadsData: Array<ILead> = new Array<ILead>();
  permLeadsData: Array<ILead> = new Array<ILead>();

  roleOptions: any = {};
  
  userRoles: Array<number> = [];
  
  reportingPeriods: Array<IReportingPeriod> = [];

  private activeUser: any = null;

  private hasInitializedTabs: boolean = false;
  private pendingTabLoadId: number | null = null;

  iframeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');

  getClientDetailsRouterLink(): any[] {
    const client = (this.campaignData as any)?.client;
    const clientId = client?.id ?? (this.campaignData as any)?.clientId;
    const isProspect = !!client?.isProspect;

    const base = this.instance.isAltLayout
      ? (isProspect ? '/pages/archived-location-details' : '/pages/location-details')
      : (isProspect ? '/pages/prospect-details' : '/pages/client-details');

    return [base, clientId];
  }

  constructor(
    private appService: AppService,
    private sanitizer: DomSanitizer,
    public uService: UtilityService,
    private route: ActivatedRoute,
    private tasksService: TasksService,
    private taskApiService: TasksApiService,
    private tagService: TagsApiService,
    private modalService: NgbModal,
    private campaignService: CampaignsApiService,
    private campaignsService: CampaignsService,
    private dataFeedService: DataFeedService,
    private tasksApi: TasksApiService,
    private leadsApi: LeadsApiService,
    private ordersApiService: OrdersApiService,
    private subscriptionService: SubscriptionApiService,
    public instance: InstanceService,
    public router: Router,
    private translate: TranslateService) {

    this.userRoles = [...this.uService.getUserRoles()];

    this.columnsTasks.push({ title: 'TITLE', field: 'title', sortable: true, searchable: true } as IColumn);
    this.columnsTasks.push({ title: 'CLIENT', field: 'clientName', sortable: true, searchable: true, anchorLink: true, anchorType: 'client', anchorParamsField: 'clientId' } as IColumn);
    this.columnsTasks.push({ title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true, anchorLink: true, anchorType: 'campaign', anchorParamsField: 'campaignId' } as IColumn);
    this.columnsTasks.push({ title: 'DUE_DATE', field: 'dueDate', sortable: true, pipe: 'P_AppDateFormat', pipeArgs: ['MM/DD/YYYY'] } as IColumn);
    this.columnsTasks.push({ title: 'ASSIGNED_USER', field: 'assignedUserName', sortable: true } as IColumn);

    this.completedTasksColumns.push({ title: 'TITLE', field: 'title', sortable: true, searchable: true } as IColumn);
    this.completedTasksColumns.push({ title: 'CLIENT', field: 'clientName', sortable: true, searchable: true, anchorLink: true, anchorType: 'client', anchorParamsField: 'clientId' } as IColumn);
    this.completedTasksColumns.push({ title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true, anchorLink: true, anchorType: 'campaign', anchorParamsField: 'campaignId' } as IColumn);
    this.completedTasksColumns.push({ title: 'COMPLETED_ON', field: 'completedOn', sortable: true, pipe: 'P_AppDateFormat', pipeArgs: ['YYYY/MM/DD HH:mm', true] } as IColumn);
    this.completedTasksColumns.push({ title: 'ASSIGNED_USER', field: 'assignedUserName', sortable: true } as IColumn);
  }

  editCampaign(): void {
    if (!this.campaignData?.id) {
      return;
    }

    const modalRef = this.campaignsService.openEditCampaignModal({ campaignId: this.campaignData.id });
    modalRef.closed.subscribe((savedCampaign?: ICampaign) => {
      if (!savedCampaign?.id) {
        return;
      }

      if (savedCampaign.id === this.campaignData.id) {
        this.loadCampaignDetails(savedCampaign.id);
        return;
      }

      this.router.navigate(['/pages/campaign-details', savedCampaign.id]);
    });
  }

  deleteCampaign(): void {
    this.campaignsService.deleteCampaign();
  }

  ngOnInit(): void {
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Campaigns);
    this.leadsPermissions = this.appService.getUserRolesForPage(PAGE_NAMES.Leads);
    this.ordersPermissions = this.appService.getUserRolesForPage(PAGE_NAMES.Orders);

    if (!this.appService.getPageTitle$().getValue()) {
      this.appService.setPageTitle$('CAMPAIGNS');
    }

    this.leadsColumns = [
      { title: 'RECEIVED_AT', field: 'createdAt', sortable: true, searchable: true, pipe: 'P_AppDateFormat', pipeArgs: ['MM/DD/YYYY HH:mm', true] },
      ...(!this.instance.isLastNameFirst ? [{ title: 'FIRST_NAME', field: 'firstName', sortable: true, searchable: true }] : [{ title: 'LAST_NAME', field: 'lastName', sortable: true, searchable: true }]),
      ...(!this.instance.isLastNameFirst ? [{ title: 'LAST_NAME', field: 'lastName', sortable: true, searchable: true }] :[{ title: 'FIRST_NAME', field: 'firstName', sortable: true, searchable: true }]),
      { title: 'EMAIL', field: 'email', sortable: true, searchable: true },
      { title: 'PHONE', field: 'phone', sortable: true, searchable: true },
      { title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true },
      { title: 'REFERRAL_SOURCE', field: 'referralSource', sortable: true, searchable: true },
      { title: 'REFERRAL_ID', field: 'referralId', sortable: true, searchable: true },
      { title: 'MEMBER', field: 'isMember', pipe: 'P_Boolean', sortable: true, searchable: true },
    ];

    this.recomputeTabOrder();

    let id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadCampaignDetails(id);
    }

    this.appService.getActiveUser$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(u => {
        this.activeUser = u;
        if (u.id !== undefined) {
          this.userId = u.id;
        }
        this.isExternal = u.type == ROLES_TYPE.External;
        // campaignData may not be loaded yet; compute ownership once we have both.
        this.updateClientOwnership();
        if (this.userRoles.includes(ROLES.Employee.Code) || this.userRoles.includes(ROLES.SubscriptionEmployee.Code)) {
          this.isEmployee = true;
        }
        var r = getRolesForPage(u.roles, PAGE_NAMES.Campaigns);
        this.isAdmin = r.isAdmin;
        if (this.isAdmin) {
          this.showOnlyMyTasks = false;
        }
        if (r.options) {
          this.roleOptions = JSON.parse(r.options!);
        }

        this.recomputeTabOrder();

        if (!this.hasInitializedTabs) {
          this.hasInitializedTabs = true;
          this.activateTab(this.getFirstVisibleTabId());
        } else {
          this.ensureActiveTabIsVisible();
        }
      });

    this.configureTasksService();
  }

  loadCampaignDetails(id: string): void {
    this.campaignService.getCampaignDetails(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.campaignData = response.data;
        this.updateClientOwnership();
        this.loadTags();
        if (this.instance.isAltLayout) {
          this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://dms.reach.marketing/dmm/alt/kpis.php?campaignID=${this.campaignData.campaignId}&platform=${this.campaignData.platform}`);
        } else {
          this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://dms.reach.marketing/dmm/kpis.php?campaignID=${this.campaignData.id}&platform=${this.campaignData.platform}`);
        }
        if (this.campaignData.subscriptionActive && !this.isExternal) {
          this.loadMostRecentOrder();
        } else {
          this.mostRecentOrder.status = `<label style="color:red">${this.translate.instant('NO_ACTIVE_SUBSCRIPTION')}</label>`;
        }

        if (this.pendingTabLoadId !== null) {
          const pending = this.pendingTabLoadId;
          this.pendingTabLoadId = null;
          this.loadDataForTab(pending);
        } else {
          this.loadDataForTab(this.active);
        }
      });
  }

  private recomputeTabOrder(): void {
    this.tabOrder = [
      { id: 1, name: 'Notes', visible: (this.isAdmin || !!this.roleOptions?.notes?.canRead) && !this.instance.isAltLayout },
      { id: 2, name: 'Tasks', visible: (this.isAdmin || !!this.roleOptions?.tasks?.canRead) && !this.instance.isAltLayout },
      { id: 3, name: 'Subscriptions', visible: (this.isAdmin || !!this.roleOptions?.subscriptions?.canRead) && !this.instance.isAltLayout },
      { id: 4, name: 'Orders', visible: (this.isAdmin || !!this.roleOptions?.subscriptions?.canRead) && !this.instance.isAltLayout },
      { id: 5, name: 'Leads', visible: this.isAdmin || !!this.roleOptions?.dashboard?.canRead },
      { id: 6, name: 'Reports', visible: this.isAdmin || !!this.roleOptions?.dashboard?.canRead },
      { id: 7, name: 'Tags', visible: this.isAdmin || !!this.roleOptions?.tags?.canRead },
      { id: 8, name: 'Audit', visible: (this.isAdmin || !!this.roleOptions?.audit?.canRead) && !this.instance.isAltLayout },
    ];
  }

  isTabVisible(tabId: number): boolean {
    return this.tabOrder.find(t => t.id === tabId)?.visible ?? false;
  }

  getFirstVisibleTabId(): number {
    return this.tabOrder.find(tab => tab.visible)?.id ?? 1;
  }

  onActiveTabChange(nextTabId: number): void {
    this.active = nextTabId;
    this.loadDataForTab(nextTabId);
  }

  private ensureActiveTabIsVisible(): void {
    if (this.isTabVisible(this.active)) return;
    this.activateTab(this.getFirstVisibleTabId());
  }

  private activateTab(tabId: number): void {
    Promise.resolve().then(() => {
      this.active = tabId;
      this.loadDataForTab(tabId);
    });
  }

  private loadDataForTab(tabId: number): void {
    switch (tabId) {
      case 1:
        if (!this.campaignData?.id) {
          this.pendingTabLoadId = tabId;
          return;
        }
        this.appService.fetchAllNotes(this.campaignData.id, NOTES_TYPE.Campaigns);
        break;
      case 2:
        this.refreshTasksData();
        break;
      case 4:
        if (!this.campaignData?.id || !this.campaignData?.clientId) {
          this.pendingTabLoadId = tabId;
          return;
        }
        this.loadOrders();
        break;
      case 5:
        if (!this.campaignData?.campaignId) {
          this.pendingTabLoadId = tabId;
          return;
        }
        this.filterLeads();
        break;
      default:
        break;
    }
  }

  private updateClientOwnership(): void {
    const clientId = this.campaignData?.clientId;
    const ownerOf = this.activeUser?.clientOwnerOf ?? [];
    this.isClientOwner = !!clientId && Array.isArray(ownerOf) && ownerOf.includes(clientId);
  }

  loadTags(): void {
    let clientId = this.campaignData.clientId;
    let campaignId = this.route.snapshot.paramMap.get('id');

    const normalizeTags = (response: any): Array<ITag> =>
      Array.isArray(response?.data) ? (response.data as Array<ITag>) : [];

    const findTierTag = (tags: Array<ITag>): ITag | undefined =>
      tags.find(t => {
        const name = (t?.name ?? '').toLowerCase();
        const categories = (t?.categories ?? '').toLowerCase();
        return name.includes('tiered pricing') || (categories === 'pricing' && name.includes('tier'));
      });

    const getAssociatedTagsSafe$ = (id: string, type: number): Observable<Array<ITag>> =>
      (this.tagService.getAssociatedTags(id, type) as unknown as Observable<any>).pipe(
        map((response: any) => normalizeTags(response)),
        catchError(() => of([] as Array<ITag>))
      );

    const campaignTags$ = campaignId
      ? getAssociatedTagsSafe$(campaignId, 1).pipe(tap(tags => (this.campaignTags = tags)))
      : of([] as Array<ITag>).pipe(tap(() => (this.campaignTags = [])));

    const clientTags$ = clientId
      ? getAssociatedTagsSafe$(clientId, 2).pipe(tap(tags => (this.clientTags = tags)))
      : of([] as Array<ITag>).pipe(tap(() => (this.clientTags = [])));

    campaignTags$
      .pipe(
        switchMap(tags => {
          const campaignTierTag = findTierTag(tags);
          if (campaignTierTag) {
            this.isTiered = true;
            this.tierName = this.extractTierName(campaignTierTag.name);
            return of(void 0);
          }

          return clientTags$.pipe(
            tap(clientTags => {
              const clientTierTag = findTierTag(clientTags);
              this.isTiered = !!clientTierTag;
              this.tierName = clientTierTag ? this.extractTierName(clientTierTag.name) : '';
            })
          );
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }

  loadMostRecentOrder(): void {
    this.subscriptionService.getAllSubscriptions(this.campaignData.id, this.campaignData.clientId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.subscriptions) {
          const subscriptions = response.subscriptions.map((x: any) => {
            x.dms = x.campaigns[0].dms;
            x.salesrep = x.campaigns[0].salesRep;
            return x;
          });
          const activeSubscription: any = subscriptions.find((sub: any) => sub.status === 'Active');
          if (activeSubscription) {
            this.subscriptionService.getSubscription(activeSubscription.id)
              .pipe(takeUntil(this.destroyed$))
              .subscribe(
                (response: any) => {
                  if (response && response.subscription.orders) {
                    const sortedOrders: Array<{ generatedOn: string; paid: boolean; isActive: boolean; refundText: string; status?: string }> = response.subscription.orders.sort((a: { generatedOn: string }, b: { generatedOn: string }) => new Date(b.generatedOn).getTime() - new Date(a.generatedOn).getTime());
                    
                    this.mostRecentOrder = sortedOrders[0];
                    this.mostRecentOrder.status = this.mostRecentOrder.paid && this.mostRecentOrder.isActive ? `<label style="color: green !important;">${this.translate.instant('PAID')} ${this.translateRefundText(this.mostRecentOrder.refundText)}</label>` : (this.mostRecentOrder.paid && !this.mostRecentOrder.isActive ? `<label style="color:red">${this.translate.instant('VOIDED')}</label>` : (!this.mostRecentOrder.paid && this.mostRecentOrder.isActive ? `<label style="color:red">${this.translate.instant('NOT_PAID')}</label>` : `<label style="color:red">${this.translate.instant('CANCELED')}</label>`));
                  }
                });
          }
        }
      });
  }

  private translateRefundText(refundText: any): string {
    const raw = String(refundText ?? '');
    const normalized = raw.toLowerCase();
    if (normalized.includes('fully refunded')) {
      return this.translate.instant('FULLY_REFUNDED_PARENTHESIS');
    }
    if (normalized.includes('partially refunded')) {
      return this.translate.instant('PARTIALLY_REFUNDED_PARENTHESIS');
    }
    return raw;
  }

  loadTasksData(id: string): void {
    this.taskApiService.getTasksByCampaign(id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.permTasksData = response.data;
        this.tasksData = this.permTasksData.filter((x: ITask) => (x.isCompleted === null || x.isCompleted === false) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true));
        this.completedTasksData = this.permTasksData.filter((x: ITask) => (x.isCompleted && x.isCompleted === true) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true));
      });
  }

  filterLeads() {
    this.leadsApi.getAllLeads({search: this.campaignData.campaignId})
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.leads) {
          this.permLeadsData = [...response.leads].filter((x: ILead) => x.campaignId == this.campaignData.id);
          this.leadsData = this.permLeadsData;
          if (!this.isLoaded) {
            this.leadsTotalCount = this.leadsData.length;
            this.isLoaded = true;
          }
        }
    });
  }

  configureTasksService() {
    this.tasksService.onSave.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.refreshTasksData();
        }
      });
    this.tasksService.onDelete.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.refreshTasksData();
        }
      });
    this.tasksService.onMarkAsComplete.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.refreshTasksData();
        }
      });
      this.tasksService.onReloadTaskData.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.refreshTasksData();
        }
      });
  }

  refreshTasksData(): void {
    let id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadTasksData(id);
    }
  }

  ngAfterViewInit() {}

  onTaskRowClick(evt: any) {
    this.tasksService.openEditTaskModal(evt, this.isAdmin || this.roleOptions.tasks.canEdit, this.isAdmin || this.roleOptions.tasks.canDelete);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onAddTask() {
    this.tasksService.openEditTaskModal({id: null, clientId: this.campaignData.clientId, campaignId: this.campaignData.id}, this.isAdmin || this.roleOptions.tasks.canEdit, this.isAdmin || this.roleOptions.tasks.canDelete);
  }

  onLoadingData(event: LoadDataFromServer) {
    this.loadEvent = event;
    if ((event.search != "") && (event.search != null)) {
      this.leadsData = this.permLeadsData.filter((x: ILead) => x.firstName.toLowerCase().includes(event.search.toLowerCase()) || x.lastName.toLowerCase().includes(event.search.toLowerCase()) || x.email.toLowerCase().includes(event.search.toLowerCase()) || x.phone.toLowerCase().includes(event.search.toLowerCase()) || x.campaignName.toLowerCase().includes(event.search.toLowerCase()) || x.referralSource.toLowerCase().includes(event.search.toLowerCase()));
      this.leadsTotalCount = this.leadsData.length;
      this.leadsData = this.leadsData.slice((event.pageNumber - 1) * Number(event.pageSize), event.pageNumber * Number(event.pageSize));
    }
    else {
      this.leadsData = this.permLeadsData.slice((event.pageNumber - 1) * Number(event.pageSize), event.pageNumber * Number(event.pageSize));
      this.leadsTotalCount = this.permLeadsData.length;
    }
  }

  onDelete(event: any) {
    this.leadsApi.deleteLead(event)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.appService.fetchAllLeads({
          SavedSearchId: this.savedSearchId,
          ...this.loadEvent
        });
      })
  }

  getRowLink(row: any) {
    return `/pages/lead-details/${row.id}`;
  }
  
  loadOrders(): void {
    this.ordersData = [];
    this.subscriptionService.getAllSubscriptions(this.campaignData.id, this.campaignData.clientId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.subscriptions) {
          response.subscriptions.forEach((subscription: any) => {
            this.subscriptionService.getSubscription(subscription.id)
              .pipe(takeUntil(this.destroyed$))
              .subscribe((response: any) => {
                if (response && response.subscription.orders) {
                  response.subscription.orders.forEach((order: any) => {
                    order.status = order.paid && order.isActive ? `<label style="color:green">${this.translate.instant('PAID')} ${this.translateRefundText(order.refundText)}</label>` : (order.paid && !order.isActive ? `<label style="color:red">${this.translate.instant('VOIDED')}</label>` : (!order.paid && order.isActive ? `<label style="color:red">${this.translate.instant('NOT_PAID')}</label>` : `<label style="color:red">${this.translate.instant('CANCELED')}</label>`));
                    order.subscriptionNumericId = subscription.numericId;
                    order.subscriptionId = subscription.id;
                    order.campaignName = subscription.campaigns[0].campaignName;
                    this.ordersData.push(order);
                  });
                  this.dataTotalCount = this.ordersData.length;
                }
              });
          });
        }
      });
  }

  getOrderRowLink(row: any) {
    return `/pages/orders/details/${row.id}`;
  }

  changeShowTasks() {
    if (this.showCompletedTasks) {
      this.showTasks = true;
      this.showCompletedTasks = false;
    }
  }
  
  changeShowCompletedTasks() {
    if (this.showTasks) {
      this.completedTasksData = this.permTasksData.filter((x: ITask) => (x.isCompleted && x.isCompleted === true) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true));
      this.showTasks = false;
      this.showCompletedTasks = true;
    }
  }

  onShowMyTasksChange() {
    this.refreshTasksData();
  }

  onTasksTabClick(): void {
    this.refreshTasksData();
  }

  onCampaignCheck(){
    const dialogRef = this.modalService.open(AddCampaignCheckModal, {
      size: 'xl',
      windowClass: 'modal-xxl',
      backdrop: 'static',
    });
    dialogRef.componentInstance.iActiveUserExternal = this.isExternal;
    dialogRef.componentInstance.isIsAdmin = this.isAdmin;
    dialogRef.componentInstance.iCampaignId = this.campaignData.id;
    dialogRef.componentInstance.iType = 1;
    dialogRef.componentInstance.isGooglePlatform = this.campaignData.platform == 'Google' ? true : false;

    const dialogSubmitSubscription = dialogRef.componentInstance.oSaveClicked.subscribe((r: ICampaignCheck) => {

      this.dataFeedService.saveCampaignCheck(r)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          dialogRef.dismiss();
          this.refreshTasksData();
          this.appService.fetchAllNotes(this.campaignData.id, 1);

          const nextAssigneeId = (r as any)?.nextTaskAssignedUserId;
          const nextDueDate = (r as any)?.addTaskDate;
          if (nextAssigneeId && nextDueDate) {
            this.reassignNextCampaignCheckTask(this.campaignData.id, nextDueDate, nextAssigneeId);
          }
        })
      dialogSubmitSubscription.unsubscribe();
    })
  }

  private reassignNextCampaignCheckTask(campaignId: string, dueDateIso: string, assignedUserId: string): void {
    const targetDue = new Date(dueDateIso);
    if (!campaignId || !assignedUserId || isNaN(targetDue.getTime())) return;

    this.tasksApi.getTasksByCampaign(campaignId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        const tasks: Array<any> = response?.data ?? [];
        const candidates = tasks
          .filter(t => (t?.title ?? '') === 'Campaign Check' && (t?.isCompleted === null || t?.isCompleted === false))
          .map(t => {
            const due = new Date(t?.dueDate);
            return { task: t, diff: Math.abs(due.getTime() - targetDue.getTime()) };
          })
          .filter(x => Number.isFinite(x.diff))
          .sort((a, b) => a.diff - b.diff);

        const best = candidates[0];
        if (!best || best.diff > 36 * 60 * 60 * 1000) return;

        // Already assigned to the desired user (e.g., campaign DMS). Nothing to do.
        if ((best.task?.assignedUserId ?? null) === assignedUserId) return;

        this.tasksApi.getTaskDetails(best.task.id)
          .pipe(takeUntil(this.destroyed$))
          .subscribe((detailsResp: any) => {
            const task = detailsResp?.data;
            if (!task?.id) return;

            // Double-check on the full task payload before saving.
            if ((task?.assignedUserId ?? null) === assignedUserId) return;
            task.assignedUserId = assignedUserId;
            this.tasksApi.saveTask(task)
              .pipe(takeUntil(this.destroyed$))
              .subscribe(() => this.refreshTasksData());
          });
      });
  }

  openLpRequestModal() {
    const id = this.route.snapshot.paramMap.get('id');
    const modalRef = this.modalService.open(LandingPageRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
    if (id) {
      modalRef.componentInstance.campaignId = id;
    }
  }
  openTechRequestModal(campaignId?: string) {
    const id = this.route.snapshot.paramMap.get('id');
    const modalRef = this.modalService.open(TechRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
    if (id) {
      modalRef.componentInstance.campaignId = id;
    }
  }
  openCreativeRequestModal() {
    const id = this.route.snapshot.paramMap.get('id');
    const modalRef = this.modalService.open(CreativeRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
    if (id) {
      modalRef.componentInstance.campaignId = id;
    }
  }

  openCreateTaskExternalModal() {
    const campaignId = this.route.snapshot.paramMap.get('id');
    const userId = this.campaignData?.dmsId;
    const clientId = this.campaignData?.clientId;
    const modalRef = this.modalService.open(CreateTaskExternalModal, { 
      size: 'md',
      backdrop: 'static',
    });
    if (campaignId) {
      modalRef.componentInstance.iCampaignId = campaignId;
    }
    if (userId) {
      modalRef.componentInstance.iUserId = userId;
    }
    if (clientId) {
      modalRef.componentInstance.iClientId = clientId;
    }
  }

  openSendEmailModal(): void {
    const campaignId = this.campaignData?.id || this.route.snapshot.paramMap.get('id');
    const clientId = this.campaignData?.clientId;

    if (!campaignId || !clientId) {
      return;
    }

    const modalRef = this.modalService.open(SendEmailModal, {
      size: 'xl',
      backdrop: 'static',
    });

    modalRef.componentInstance.iCampaignId = campaignId;
    modalRef.componentInstance.iClientId = clientId;
    modalRef.componentInstance.iType = NOTES_TYPE.Campaigns;

    void modalRef.result.then((result: any) => {
      if (result?.saved) {
        this.appService.fetchAllNotes(campaignId, NOTES_TYPE.Campaigns);
      }
    }, (): void => undefined);
  }

  openStrategyReviewModal() {
    const campaignId = this.route.snapshot.paramMap.get('id');
    const clientId = this.campaignData?.clientId;
    const clientName = (this.campaignData as any)?.client?.clientName ?? (this.campaignData as any)?.clientName ?? '';
    const campaignName = this.campaignData?.name ?? '';
    const dmsName = this.campaignData?.dmsName ?? '';
    const modalRef = this.modalService.open(StrategyReviewFormComponent, { 
      size: 'md',
      backdrop: 'static',
    });
    if (campaignId) {
      modalRef.componentInstance.iCampaignId = campaignId;
    }
    if (clientId) {
      modalRef.componentInstance.iClientId = clientId;
    }
    if (clientName) {
      modalRef.componentInstance.iClientName = clientName;
    }
    if (campaignName) {
      modalRef.componentInstance.iCampaignName = campaignName;
    }
    if (dmsName) {
      modalRef.componentInstance.iDmsName = dmsName;
    }
  }

  openCampaignAnalysisModal(): void {
    const campaignId = this.route.snapshot.paramMap.get('id');
    const modalRef = this.modalService.open(CampaignAnalysisModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    if (campaignId) {
      modalRef.componentInstance.campaignId = campaignId;
    }
    modalRef.componentInstance.isAdmin = this.isAdmin;
  }

  private extractTierName(tagName: string): string {
    if (!tagName) return '';

    // Expected examples:
    // - "Tiered Pricing | Standard Tier"
    // - "Tiered Pricing|Premium Tier"
    // - "Tiered Pricing - Standard Tier"
    const partsPipe = tagName.split('|').map(p => p.trim()).filter(Boolean);
    if (partsPipe.length >= 2) {
      return partsPipe[1];
    }

    const lower = tagName.toLowerCase();
    const idx = lower.indexOf('tiered pricing');
    if (idx >= 0) {
      const after = tagName.slice(idx + 'tiered pricing'.length).replace(/^\s*[-:]\s*/, '').trim();
      return after || tagName;
    }

    return tagName;
  }
}
